import React from 'react';
import WithTexts from './WithTexts';
import ImageSign from './ImageSign';

function Quiz(props) {
  const type = props.exerciseProps.exercise.type;
  
  switch (type) {
    case 'STANDARD':
      return <WithTexts {...props}/>;
    case 'WITH_TEXTS':
      return <WithTexts {...props}/>;
    case 'IMAGE_SIGN':
      return <ImageSign {...props}/>;
    default:
      return <p>Nieznany typ quizu: {type}</p>
  }
}

export default Quiz;